var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es325.js.map
